import { useCallback, useMemo } from 'react';

import { getModuleRight, useModuleRights } from '@work4all/data';

import { ModuleAccessRightDenyReason } from '@work4all/models/lib/Enums/ModuleAccessRightDenyReason.enum';
import { ModuleAccessRightType } from '@work4all/models/lib/Enums/ModuleAccessRightType.enum';

import { settings, useSetting } from '../../settings';

export const useToniAiRights = () => {
  const { rights: moduleAccessRights, refetch: refetchModuleAccessRights } =
    useModuleRights();

  const { set: setAiToolsEnabled } = useSetting(settings.aiToolsUsageEnabled());

  const featureAiTools = getModuleRight(
    moduleAccessRights,
    ModuleAccessRightType.FEATURE_AI_TOOLS
  );

  const setAiToolsFeatureEnabled = useCallback(
    async (enabled: boolean) => {
      await setAiToolsEnabled(enabled);
      refetchModuleAccessRights();
    },
    [setAiToolsEnabled, refetchModuleAccessRights]
  );

  const aiToolsAvailable =
    featureAiTools?.hasAccess ||
    featureAiTools?.moduleAccessRightDenyReason ===
      ModuleAccessRightDenyReason.DEACTIVATED_BY_SETTING;

  const aiToolsFeatureEnabled = featureAiTools?.hasAccess;

  return useMemo(
    () => ({
      aiToolsAvailable,
      aiToolsFeatureEnabled,
      setAiToolsFeatureEnabled,
    }),
    [aiToolsAvailable, aiToolsFeatureEnabled, setAiToolsFeatureEnabled]
  );
};
